import {ContentTop, ContentXsTop} from "../../../../../components/ui/Content";
import {Caption2, Subhead2} from "../../../../../components/Font";
import {InputElement} from "../../../../../ui/Input/Input";
import moment from "moment";
import React, {useEffect, useState} from "react";
import {useTheme} from "styled-components";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {cleanError} from "../../api/slice";
import {IForeignPassportInput} from "../ChangePassport";
import {DatePicker} from "../../../../../ui/FormDatePicker/DatePickerSelectors";
import {ICitizenship} from "../../../../../interface/Passport/Account/frontend";

interface IPassportProps {
    onChange(info: IForeignPassportInput): void
    selectedCountry: ICitizenship | null
}

export const ForeignPassport = ({onChange, selectedCountry}: IPassportProps) => {

    const dispatch = useAppDispatch()
    const Theme = useTheme()
    const {foreign_passport, error} = useAppSelector(state => state.account)

    const [info, setInfo] = useState<IForeignPassportInput>({
        citizenship_id: 0,
        identity_card_type_id: null,
        number: '',
        issued_at: null,
        expires_at: null
    })
    useEffect(() => {
        onChange(info)
    }, [info])

    useEffect(() => {
        if (foreign_passport) {
            setInfo({
                ...info,
                citizenship_id: foreign_passport.citizenship_id,
                identity_card_type_id: foreign_passport.identity_card_type_id,
                number: foreign_passport.number,
                issued_at: foreign_passport.issued_at,
                expires_at: foreign_passport.expires_at
            })
        } else if (selectedCountry) {
            setInfo({
                citizenship_id: 0,
                identity_card_type_id: null,
                number: '',
                issued_at: null,
                expires_at: null
            })
        }
    }, [foreign_passport])

    useEffect(()=>{
    if(info?.issued_at?.isAfter(info?.expires_at)){
        setInfo({
            ...info,
            expires_at: info.issued_at

        })
    }
    },[info.issued_at])

    useEffect(()=>{
        if(info?.expires_at?.isBefore(info?.issued_at)){
            setInfo({
                ...info,
                issued_at: info.expires_at
            })
        }
    },[info.expires_at])

    return (
        <>
            <ContentTop>
                <Subhead2>
                    Заграничный паспорт
                </Subhead2>
            </ContentTop>

            <ContentTop>
                <Caption2 color={Theme.color.secondary}>
                    Номер
                </Caption2>
                <ContentXsTop>
                    <InputElement
                        regex={/^[a-zA-Z0-9\s\-_\.\,\;\:\!\#\^\&\*\(\)\+\=\~]*$/}
                        error={error['number']}
                        value={info.number}
                        onChange={value => {
                            setInfo({...info, number: value})
                            if (error['number']) {
                                dispatch(cleanError('number'))
                            }
                        }}/>
                </ContentXsTop>
            </ContentTop>

            <ContentTop>
                <Caption2 color={Theme.color.secondary}>
                    Дата выдачи
                </Caption2>
                <ContentXsTop>
                    <DatePicker initDate={moment(info.issued_at).isValid() ? moment(info.issued_at) : null}
                                error={error['issued_at']}
                                onChange={(date) => {
                                    if (error['issued_at']) {
                                        dispatch(cleanError('issued_at'))
                                    }
                                    setInfo({...info, issued_at: moment(date)})
                                }}/>
                </ContentXsTop>
            </ContentTop>

            <ContentTop>

                <Caption2 color={Theme.color.secondary}>
                    Дата окончания действия срока
                </Caption2>
                <ContentXsTop>
                    <DatePicker initDate={moment(info.expires_at).isValid() ? moment(info.expires_at) : null}
                                maxDate={info.issued_at}
                                minDate={info.issued_at}
                                yearsReverse
                                error={error['expires_at']}
                                onChange={(date) => {
                                    if (error['expires_at']) {
                                        dispatch(cleanError('expires_at'))
                                    }
                                    setInfo({...info, expires_at: moment(date)})
                                }}/>
                </ContentXsTop>
            </ContentTop>
        </>
    )
}
